// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import { Observer } from "mobx-vue";

@Observer
@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
  },
})
export class AbhCertificateModule extends ModuleBase {
  public getBackgroundColorFromInstance(instance: object) {
    return instance["background"];
  }

  get info() {
    return this.instance["info"];
  }

  get topicLine() {
    return this.info.topicLine;
  }

  get headline() {
    return this.info.headline;
  }

  get text() {
    return this.info.text;
  }

  get linkText() {
    return this.info.linktext;
  }

  get urlLink() {
    return this.info.link.href;
  }
}
